define('modules/htmlad/templates/htmlad_templates_collection',[
  'backbone',
  'jquery',
  '_',

  '../template/htmlad_template_model',

  'session'
], function (Backbone, $, _,
             TemplateModel,
             session) {
  'use strict';
  var TemplatesCollection = Backbone.Collection.extend({
    model: TemplateModel,

    params: {
      search: null,
      order_by: 'current',
      order: 'ASC'
    },

    parse: function (response) {
      if (response.metadata) {
        this.params = _.extend(this.params, response.metadata);
      }
      return response.data;
    },

    url: function () {
      return session.get('apiUrl') + 'htmltemplates?' + $.param(this.params || {});
    }
  });

  return new TemplatesCollection();
});

